import { QUICK_FILTERS_KEY } from "modules/common/constants/QuickFilters";

import type { DefaultFilterConfiguration } from "modules/common/hooks/useGetUrlFilters";

import type { CustomerFiltersType } from "../models/CustomerFilter";

export const DEFAULT_FILTERS = {
  customerType: [],
  quickFilters: [],
  id: [],
  countryCode: [],
  calculatedIntegrator: [],
  calculatedIntegratorNull: false,
} as const satisfies CustomerFiltersType;

export const FILLED_FILTERS = {
  customerType: ["payment_service_provider"],
  id: [],
  quickFilters: ["active"],
  countryCode: [],
  calculatedIntegrator: [],
  calculatedIntegratorNull: false,
} as const satisfies CustomerFiltersType;

const parseBooleanParam = (value: string) => value === "true";

export const DEFAULT_FILTERS_CONFIGURATION = {
  customerType: {
    array: true,
    defaultValue: [],
  },
  quickFilters: {
    array: true,
    defaultValue: [],
  },
  id: {
    array: true,
    defaultValue: [],
  },
  countryCode: {
    array: true,
    defaultValue: [],
  },
  calculatedIntegrator: {
    array: true,
    defaultValue: [],
  },
  calculatedIntegratorNull: {
    array: false,
    defaultValue: false,
    parser: parseBooleanParam,
  },
} as const satisfies DefaultFilterConfiguration<CustomerFiltersType>;

export const FILTERS_KEYS = {
  CUSTOMER_TYPE: "customerType",
  CUSTOMER_ID: "id",
  QUICK_FILTERS: QUICK_FILTERS_KEY,
  COUNTRY: "countryCode",
  CALCULATED_INTEGRATOR: "calculatedIntegrator",
  CALCULATED_INTEGRATOR_NULL: "calculatedIntegratorNull",
} as const;

// Value accepted by the backend `[nullable]` entity filter to match null columns.
export const NULLABLE_FILTER_IS_NULL = "isNull";

// Backend query params that translate the frontend "not set" toggles into the
// `[nullable]` entity filter exposed by GET /customers.
export const NULLABLE_FILTER_QUERY_PARAMS = {
  calculatedIntegrator: "calculatedIntegrator[nullable]",
  parent: "parent[nullable]",
} as const;
